import { render, staticRenderFns } from "./InviteLearners.vue?vue&type=template&id=8ea95ec8&scoped=true&"
import script from "./InviteLearners.vue?vue&type=script&lang=js&"
export * from "./InviteLearners.vue?vue&type=script&lang=js&"
import style0 from "./InviteLearners.vue?vue&type=style&index=0&id=8ea95ec8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea95ec8",
  null
  
)

export default component.exports